<!--
 * @Author: cmchiu
 * @Date: 2023-04-07 12:01:46
 * @LastEditTime: 2023-05-10 12:33:21
 * @LastEditors: cmchiu
 * @Description: 
 * @FilePath: \IACMP\IACMP_Client\src\views\PostList.vue
 * 
-->
<template>
    <div class="item-post-list">
        <breadcrumb />

        <el-row v-if="newsLs && newsLs.length > 0">
            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="6" v-for="news in newsLs" :key="news.sno">
                <router-link :to="resolveRouterLinkPath('Post', $route.path, { id: MenuID, sno: news.sno })">
                    <el-card
                        :body-style="{ padding: '0px' }"
                        style="margin-top: 15px; margin-bottom: 15px; margin-left: 9px; margin-right: 9px"
                    >
                        <div
                            class="news__img w-100"
                            style="background-repeat: no-repeat; /* background-size: contain */"
                            :style="
                                news.ItemImages && news.ItemImages.length > 0
                                    ? `background-image: url(${news.ItemImages[0].location});`
                                    : ''
                            "
                            v-if="news.ItemImages && news.ItemImages.length > 0"
                        ></div>
                        <div style="padding: 14px">
                            <p class="news__date" v-text="news.UpdDate ? news.UpdDate.substr(0, 10) : 'N/A'"></p>
                            <h3 v-text="news.ItemTitle" style="margin-bottom: 9px"></h3>
                            <p v-text="news.ItemSubTitle" style="font-size: 12px"></p>
                        </div>
                    </el-card>
                </router-link>
            </el-col>
        </el-row>
        <el-row justify="center" v-else>
            <el-col :span="24">
                <h3>目前暫無相關資訊</h3>
            </el-col>
        </el-row>

        <div style="text-align: center; padding: 15px 0" v-if="newsLs && newsLs.length > 0">
            <el-button
                round
                @click="loadMorePost(pages.pageCurrent + 1)"
                :disabled="Math.ceil(pages.totalResult / pages.pageSize) <= pages.pageCurrent"
                >查看更多···</el-button
            >
        </div>
    </div>
</template>

<script>
import XEUtils from 'xe-utils'
import { getItemContent } from '@/api/common'
import { breadcrumb } from '@c'
import { resolveRouterLinkPath } from '@/utils/common'

export default {
    name: 'itemPostList',

    components: { breadcrumb },

    data() {
        return {
            configs: {
                loading: false,
            },
            MenuID: this.$route.query.id,
            newsLs: [],
            pages: {
                totalResult: 0, // 總筆數
                pageSize: 24, // 分頁大小
                pageCurrent: 1, // 目前頁次
            },
        }
    },

    created() {
        this.getMenuItemLs()
    },

    methods: {
        async getMenuItemLs(chgFilters) {
            const vm = this
            vm.configs.loading = true
            if (chgFilters) vm.pages.pageCurrent = 1 //當條件改變時, 將當前頁次改回第1頁
            let params = {
                MenuID: vm.MenuID,
                // ItemStatus: vm.filter.status,
                // Keyword: vm.filter.keyword,
                PageSize: vm.pages.pageSize,
                PageCurrent: vm.pages.pageCurrent,
            }
            await getItemContent(params)
                .then(res => {
                    // handle success
                    // vm.newsLs = res.Items
                    XEUtils.arrayEach(res.Items, item => {
                        item.ItemImages = JSON.parse(item.ItemImages)
                        XEUtils.arrayEach(item.ItemImages, data => {
                            data.location = encodeURI(data.location)
                        })
                        item.ItemFiles = JSON.parse(item.ItemFiles)
                        XEUtils.arrayEach(item.ItemFiles, data => {
                            data.location = encodeURI(data.location)
                        })
                        vm.newsLs.push(item)
                    })
                    let pages = vm.pages
                    pages.totalResult = res.TotalResult
                    if (Math.ceil(pages.totalResult / pages.pageSize) < pages.pageCurrent) {
                        pages.pageCurrent = 1
                    }
                })
                .catch(err => {
                    // handle error
                    vm.newsLs = []
                    console.log(err)
                })
                .finally(() => {
                    // always executed
                    vm.configs.loading = false
                })
        },

        loadMorePost(currentPage) {
            let page = this.pages
            page.pageCurrent = currentPage
            // page.pageSize = pageSize
            this.getMenuItemLs()
        },

        resolveRouterLinkPath,
    },
}
</script>

<style scoped lang="scss"></style>
